"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculatedPackageDto = exports.CalculatePackageQueryDto = exports.CalculatePackageDto = exports.PackageTimesDto = exports.RentalTimeSlotDto = exports.BySpaceAndOrganizationIdDto = exports.ByFacilityAndOrganizationIdDto = exports.CheckAvailabilityDto = exports.CheckFacilityAvailabilityDto = exports.TimeOfDayDto = void 0;
const activityTimes_dto_1 = require("../../dto/activityTimes.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
class TimeOfDayDto {
}
exports.TimeOfDayDto = TimeOfDayDto;
class CheckFacilityAvailabilityDto {
}
exports.CheckFacilityAvailabilityDto = CheckFacilityAvailabilityDto;
class CheckAvailabilityDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.CheckAvailabilityDto = CheckAvailabilityDto;
class ByFacilityAndOrganizationIdDto {
}
exports.ByFacilityAndOrganizationIdDto = ByFacilityAndOrganizationIdDto;
class BySpaceAndOrganizationIdDto {
}
exports.BySpaceAndOrganizationIdDto = BySpaceAndOrganizationIdDto;
class RentalTimeSlotDto extends activityTimes_dto_1.ActivityTimesDto {
}
exports.RentalTimeSlotDto = RentalTimeSlotDto;
class PackageTimesDto {
}
exports.PackageTimesDto = PackageTimesDto;
class CalculatePackageDto {
}
exports.CalculatePackageDto = CalculatePackageDto;
class CalculatePackageQueryDto {
}
exports.CalculatePackageQueryDto = CalculatePackageQueryDto;
class CalculatedPackageDto {
}
exports.CalculatedPackageDto = CalculatedPackageDto;
//# sourceMappingURL=online-rentals.dto.js.map